document.addEventListener("DOMContentLoaded", function () {
    // Select all swatches
    const swatches = document.querySelectorAll('.product-swatch-inline__dot');
  
    // Check if swatches are found
    // console.log(`Found ${swatches.length} swatches`);
  
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function () {
        // Log when a swatch is clicked
        // console.log("Swatch clicked!");
  
        // Get the variant id associated with this swatch
        const variantId = this.getAttribute('data-variant-id');
        // console.log(`Variant ID: ${variantId}`);
  
        // Get the closest product container for this swatch
        const productContainer = this.closest('.product-block');
        if (!productContainer) {
          console.error("Product container not found!");
          return;
        }
  
        const productId = productContainer.querySelector('.product-images').getAttribute('data-product-id');
        // console.log(`Product ID: ${productId}`);
  
        // Get the image URL for the selected variant
        const variantImageElement = productContainer.querySelector(`.variant-image[data-variant-id="${variantId}"]`);
        if (!variantImageElement) {
          console.error("Variant image not found for this variant ID!");
          return;
        }
  
        const variantImage = variantImageElement.getAttribute('src');
        // console.log(`Variant Image URL: ${variantImage}`);
  
        // Update the main product image for the correct product (using the unique product id)
        const mainImage = productContainer.querySelector(`.main-product-image-${productId}`);
        if (!mainImage) {
          console.error("Main product image not found for this product ID!");
          return;
        }
  
        // console.log(`Updating main image for product ${productId} with image: ${variantImage}`);
        mainImage.setAttribute('src', variantImage);
      });
    });
  });

// Select all toggle buttons
const toggleButtons = document.querySelectorAll(".toggleButton");

toggleButtons.forEach(button => {
    button.addEventListener("click", function () {
        // Get the corresponding .product-swatch-inline container
        const swatchContainer = this.previousElementSibling;
        
        // Toggle the 'expanded' class
        swatchContainer.classList.toggle("expanded");
        
        // Update button text based on the state
        if (swatchContainer.classList.contains("expanded")) {
            this.textContent = "Show Less...";
        } else {
            this.textContent = "Show More...";
        }
    });
});

  